import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { CustomerTypeSPModel } from "../../models/CustomerTypeSPModel";
import CustomerTypeSPService from "../../services/CustomerTypeSPService";
import CustomerTypeSPSlice from "../slices/CustomerTypeSPSlice";
import { RootState } from "../store";

export const CustomerTypeSPActions = CustomerTypeSPSlice.actions;

export const fetchParticularCustomerTypeSP = (CustomerTypeSP_id: number): ThunkAction<void, RootState, unknown, AnyAction> => {
    return async (dispatch, getState) => {
        const response: CustomerTypeSPModel = await CustomerTypeSPService.getParticularCustomerTypeSP(CustomerTypeSP_id);
        dispatch(CustomerTypeSPActions.setParticularCustomerTypeSP(response));
    }
}